export const AUS_TIME_ZONE = {
  UTC800: {
    area: 'Australia/Perth',
    offset: 480, //8 x 60
    displayText: 'UTC+8:00 (AWST)',
  },
  UTC845: {
    area: 'Australia/Eucla',
    offset: 525,
    displayText: 'UTC+8:45 (ACWST)',
  },
  UTC930: {
    area: 'Australia/Adelaide',
    offset: 570,
    displayText: 'UTC+9:30 (ACST)',
  },
  UTC1000: {
    area: 'Australia/Melbourne',
    offset: 600,
    displayText: 'UTC+10:00 (AEST)',
  },
};
